import { useEffect, useState } from 'react';

const usePages = ({ pages }) => {
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [transcription, setTranscription] = useState("");
  const [chapterComplete, setChapterComplete] = useState(false);
  const [chapterStart, setChapterStart] = useState(false);

  const currentPage = pages[currentPageIndex];
  const currentPageName = currentPage?.name || "";

  const onNextPage = () => {
    if (currentPageIndex < pages.length - 1) {
      setCurrentPageIndex(currentPageIndex + 1);
    }
  };

  const onPreviousPage = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };

  const onResetPages = () => {
    setCurrentPageIndex(0);
  };

  const goToPage = (pageName) => {
    const index = pages.findIndex(page => page.name === pageName);
    if (index !== -1) setCurrentPageIndex(index);
  };

  const getIsMobile = () => {
    if (window?.innerWidth && document?.documentElement?.clientWidth) {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      if (viewportWidth <= 500) {
        setIsMobile(true);
      }
    }
  };

  useEffect(() => {
    getIsMobile();
  }, []);

  useEffect(() => {
    if (chapterComplete) {
      setTranscription("");
      setChapterComplete(false);
    }
  }, [chapterComplete]);

  useEffect(() => {
    if (chapterStart) {
      setTranscription("");
      setChapterStart(false);
    }
  }, [chapterStart]);

  return {
    isMobile,
    currentPage,
    currentPageName,
    onNextPage,
    onPreviousPage,
    onResetPages,
    goToPage,
    transcription,
    setTranscription,
    chapterComplete,
    setChapterComplete,
    chapterStart,
    setChapterStart,
  };
};

export default usePages;
